import React, { useState, useEffect, useRef } from "react";
import styles from "./GetStarted.module.css";
import { Link } from "react-router-dom";

export default function GetStarted() {
  

  return (
    <div className={styles.mainContainer}>
      <div className={styles.subContainer}>
        <div className={styles.GradientL}></div>
        <div className={styles.GradientR}></div>
        <div className={styles.heading}>
          <h1>Get Started with</h1>
          <h1>Ÿ Data solutions.</h1>
          <p>Launch Products with Ÿ Oracle as your backbone.</p>
        </div>
        <div className={styles.LogoContainer}>
          <img src="/images/headerLogo.svg" />
        </div>

        <div className={styles.linkContainer}>
          <Link to="/legal" className={styles.linkItem}>
            Legal
          </Link>
        </div>

        <div className={styles.copyright}>
          Copyright © Y 2026. All rights reserved
        </div>
      </div>
    </div>
  );
}
